import { Box, List, ListItem, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";



function PrivacyPolicy() {
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [])

    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Typography
                component="h1"
                variant="h1"
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0
                }}
            >
                App Gallery Pty Ltd (ABN: 26 617 628 592)
            </Typography>
            <Typography data-aos="fade-up" gutterBottom mt={{ xs: 2, md: 3, lg: 5 }} className='fs-52 text-color-main' fontWeight={500}>App Gallery Pty Ltd (ABN: 26 617 628 592)</Typography>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    1. Introduction
                </Typography>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    App Gallery Pty Ltd (“App Gallery”, “we”, “us”, or “our”) is committed to protecting the privacy of personal information in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs). This policy outlines how we handle personal information as an Australian-based software development firm.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    2. Scope and Role
                </Typography>
                <Typography data-aos="fade-up" ml={{ xs: 0, md: "auto" }} className='fs-16 text-grey'>
                    App Gallery provides software development, maintenance, and consulting services strictly within infrastructure owned or provisioned by our clients.
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Service Provider Role:</strong> We act as a service provider (data processor). Our clients act as the Data Controller and maintain primary responsibility for the personal information within their applications.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>No Internal Data Storage:</strong> App Gallery does not host, store, or process client-controlled personal information on its own internal servers or databases.
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    3. Collection and Access of Personal Information
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    Our engagement model is designed to minimise the collection of personal information:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Business Contact Information:</strong> We collect names, email addresses, and phone numbers of client representatives strictly for project management, contract administration, and billing.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Zero Technical Data Ingestion:</strong> Any technical metadata, system logs, or device information remain within the client’s infrastructure.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Incidental Access:</strong> Our personnel may access client data during development or testing, but it is never collected, downloaded, or retained.
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    4. Use of Personal Information
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We use the limited business contact information we collect to:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Manage project delivery and communication.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Process invoices and fulfil contracts.</Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>Comply with legal and tax obligations.</Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We do not use personal information for marketing without consent.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    5. Disclosure of Personal Information
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We may disclose personal information to:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Employees and contractors</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Professional advisors</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Client-authorised third parties</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}><Typography data-aos="fade-up" className='fs-16 text-grey'>Service providers</Typography></ListItem>
                </List>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We do not sell personal information.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    6. Hosting and Infrastructure
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    App Gallery does not provide hosting services.
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            All environments are provisioned and controlled by the client.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            Clients manage data residency and infrastructure security.
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    7. Data Security
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    Because we operate within client-managed environments, our focus is on access integrity:
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Secure Development:</strong> We follow industry-standard practices.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>No Local Storage:</strong> Client data is never stored locally.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Access Protocols:</strong> We follow client security and MFA policies.
                        </Typography>
                    </ListItem>
                </List>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We cannot guarantee security within client-controlled systems.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    8. Data Retention
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4 }}>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Client Systems:</strong> Managed by the client.
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item', p: 0 }}>
                        <Typography data-aos="fade-up" className='fs-16 text-grey'>
                            <strong>Business Records:</strong> Retained as required by law (typically 7 years).
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    9. Access and Correction
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    Individuals may request access or correction of their personal information. Requests may be redirected to the relevant client where applicable.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    10. Cross-Border Disclosure
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We may use personnel outside Australia and ensure compliance through strict contractual obligations.
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    11. Complaints and Contact
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    App Gallery Pty Ltd
                    <br />
                    Email: info@appgallery.com.au
                    <br />
                    Address: 8/330 Collins St, Melbourne VIC 3000
                </Typography>
            </Box>

            <Box className='mb-3'>
                <Typography data-aos="fade-up" className='fs-32 fw-bold text-color-main mb-2' >
                    12. Changes to this Policy
                </Typography>
                <Typography data-aos="fade-up" className='fs-16 text-grey'>
                    We may update this policy from time to time. Latest version available upon request. (Last Updated: April 2026)
                </Typography>
            </Box>

        </Box>
    )
}

export default PrivacyPolicy
